<div *ngIf="prikaziStranicu" class="container-fluid">
  <div class="content-block">
    <h2>Popis uređaja</h2>
  </div>
  <div class="content-block">
    <div class="customTable">
      <dx-data-grid
        class="my-40"
        [dataSource]="uredjajiPopis"
        [showColumnLines]="true"
        noDataText="{{ noDataMessage }}"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        keyExpr="id_uredjaj"
        [disabled]="pravaZaTrenutniPogled != 2">

        
        <dxi-column
          dataField="ur_aktivan"
          caption="Autoriziran"
          [width]="120"
          alignment="center"
          cellTemplate="cellCheckbox"
        ></dxi-column>

        <div *dxTemplate="let row of 'cellCheckbox'">
          <dx-check-box [value]="row.data.ur_aktivan"
            (onValueChanged)="promjeniStatus($event, row)"
          ></dx-check-box>
        </div>

        <dxi-column
          dataField="ur_model"
          caption="Marka"
          [width]="200"
        ></dxi-column>
        <dxi-column
          dataField="ur_marka"
          caption="Model"
          [width]="200"
        ></dxi-column>
        <dxi-column
          dataField="sec_user_login"
          caption="Login"
          [width]="300"
        ></dxi-column>
        <dxi-column
          dataField="ur_vrijemeprijave"
          dataType="datetime"
          caption="Vrijeme prijave"
          [width]="200"
          alignment="center"
        ></dxi-column>
        
      </dx-data-grid>
    </div>
  </div>
</div>
